import { createFileRoute } from "@tanstack/react-router";
import { AttributionsEditor } from "@/features/admin-attributions/AttributionsEditor";
function Page() { const { session } = Route.useRouteContext(); return <AttributionsEditor key={session.user.id} actorId={session.user.id} />; }
export const Route = createFileRoute("/_authenticated/_protected/_admin/admin/attributions")({ component: Page });
